import React from 'react';
import { useParams } from 'react-router-dom';
import { VaultPageTab } from './VaultPageTab';
import { Box } from '../../core';
import type { BoxProps } from 'theme-ui';
import { BackToVaults } from '../../nav';
import { IStratInfo } from '@sc1/common';

type TTab = 'vault' | 'info' | 'performance' | 'admin' | 'strategies';
interface VaultPageTabsProps extends BoxProps {
  tab?: TTab;
  strategies: IStratInfo[] | null;
  isAdmin: boolean;
}

function match(x: string | undefined, y: string): boolean {
  return x === y;
}

export const VaultPageTabs = ({
  tab,
  strategies,
  isAdmin,
  ...props
}: VaultPageTabsProps): JSX.Element => {
  const { strategyAddress } = useParams();
  return (
    <Box {...props}>
      <BackToVaults sx={{ mr: 4 }} />
      <VaultPageTab
        match={match(tab, 'vault')}
        label="vault"
        value={undefined}
      />
      <VaultPageTab match={match(tab, 'info')} label="info" value="info" />
      <VaultPageTab
        match={match(tab, 'performance')}
        label="performance"
        value="performance"
      />
      {isAdmin && (
        <VaultPageTab match={match(tab, 'admin')} label="admin" value="admin" />
      )}
      {isAdmin &&
        strategies &&
        strategies.map((x) => (
          <VaultPageTab
            key={x.address}
            label={x.symbol}
            match={strategyAddress === x.address}
            value={`strategies/${x.address}`}
          />
        ))}
    </Box>
  );
};
